import { z } from 'zod';

export const drivingRangeGameTypesScheme = z.object({
  bays: z.array(
    z.object({
      challengeConfigId: z.number().int().min(1).max(2147483647).nullable(),
    })
  ),
});

export type DrivingRangeGameTypesForm = z.infer<typeof drivingRangeGameTypesScheme>;
